import styled, { css } from 'styled-components'
import { background, BackgroundProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { LANDING_MAX_CONTENT_WIDTH_PX } from 'Constants/Landing'

export const SectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${LANDING_MAX_CONTENT_WIDTH_PX}px;
  padding: 120px 16px 0 16px;
  background-color: ${themeGet('colors.surface.block')};

  @media screen and (min-width: ${themeGet('breakpoints.1')}) {
    padding: 120px 40px 0 40px;
  }

  @media screen and (min-width: ${themeGet('breakpoints.5')}) {
    border-radius: 40px 40px 0 0;
  }
`

export const SectionTitle = styled.div`
  margin: 0;
  padding: 0;
  color: ${themeGet('colors.text.title')};
  font-weight: 500;
  font-size: 52px;
  line-height: 64px;

  @media screen and (min-width: ${themeGet('breakpoints.2')}) {
    font-size: 64px;
    line-height: 72px;
  }

  @media screen and (min-width: ${themeGet('breakpoints.3')}) {
    font-size: 80px;
    line-height: 96px;
  }
`

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  gap: ${themeGet('space.1')}px;
  width: 100%;
  min-width: 0;
  margin: 0 auto;

  > *:first-child {
    border-radius: 24px 24px 0 0;
  }

  > *:last-child {
    border-radius: 0 0 24px 24px;
  }

  @media screen and (min-width: ${themeGet('breakpoints.3')}) {
    grid-template-columns: repeat(3, 1fr);
    justify-items: initial;

    > *:first-child {
      border-radius: 32px 0 0 32px;
    }

    > *:last-child {
      border-radius: 0 32px 32px 0;
    }
  }
`

// A real anchor (product cards link out to the live products — link equity
// + entity association); reset UA link styling so the card look is
// unchanged.
export const Card = styled.a<BackgroundProps>`
  display: block;
  overflow: hidden;
  max-width: calc(min(520px, 100%));
  min-width: 0;
  color: inherit;
  text-decoration: none;

  ${background}
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;
`

type CardImageProps = {
  bleedImageRight?: boolean
}

const cardImageBleedImageRightCss = ({ bleedImageRight }: CardImageProps) =>
  bleedImageRight &&
  css`
    padding-right: 0;
    > img {
      object-fit: cover;
      object-position: left;
    }
  `

const cardImageShouldForwardProp = (prop: string) => {
  return prop !== 'bleedImageRight'
}

export const CardImage = styled.div.withConfig({
  shouldForwardProp: cardImageShouldForwardProp,
})<CardImageProps>`
  width: 100%;
  display: flex;
  align-items: flex-end;
  margin-top: auto;
  padding: 0 32px 32px 32px;

  > img {
    display: block;
    width: 100%;
    height: auto;
    object-fit: contain;
  }

  ${cardImageBleedImageRightCss}
`

export const CardLogo = styled.div`
  display: flex;
  flex-shrink: 0;
  width: 40px;
  height: 40px;

  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`
